import { combineReducers } from 'redux';
import authReducer from './authReducer';

// Set 'auth' and 'roles' redux state from authReducer and roleReducer respectively
export default combineReducers({
  auth: authReducer,
});
